import { IBookingCalendarStore } from '../index'

export default function(state: IBookingCalendarStore): IBookingCalendarStore {
  delete state['rooms']
  return {
    ...state,
  }
}
